<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="New Vendor" scrollable hide-footer size="lg">
            <template v-slot:modal-title>
                <span>New Vendor:</span>
            </template>

            <b-form @submit.stop.prevent="createvendor">
                <b-row>
                    <b-col>
                        <b-form-group
                            id="input-group-name"
                            label="Name:"
                            label-for="input-name"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-name"
                                v-model="create.name"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-company"
                            label="Company:"
                            label-for="input-company"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-company"
                                v-model="create.company"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-contact"
                            label="Contact:"
                            label-for="input-contact"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-contact"
                                v-model="create.contact"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group
                            id="input-group-email"
                            label="Email:"
                            label-for="input-email"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-email"
                                v-model="create.email"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-row>
                            <b-col>
                                <b-form-group
                                    id="input-group-phone"
                                    label="Phone:"
                                    label-for="input-phone"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-phone"
                                        v-model="create.phone"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-mobile"
                                    label="Mobile:"
                                    label-for="input-mobile"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-mobile"
                                        v-model="create.mobile"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-fax"
                                    label="Fax:"
                                    label-for="input-fax"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-fax"
                                        v-model="create.fax"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="4">
                                <b-form-group
                                    id="input-group-other"
                                    label="Other:"
                                    label-for="input-other"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-other"
                                        v-model="create.other"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="8">
                                <b-form-group
                                    id="input-group-website"
                                    label="Website:"
                                    label-for="input-website"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-website"
                                        v-model="create.website"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-row>

                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Address" active>
                            <b-card-text>
                                <b-form-row>
                                    <b-col>
                                        <b-form-group
                                            id="input-group-billing-address-1"
                                            label="Billing Address Line 1:"
                                            label-for="input-billing-address-1"
                                            label-size="sm"
                                        >
                                            <b-form-input
                                                id="input-billing-address-1"
                                                v-model="create.billingAddress1"
                                                type="text"
                                                placeholder=""
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group
                                            id="input-group-billing-address-2"
                                            label="Billing Address Line 2:"
                                            label-for="input-billing-address-2"
                                            label-size="sm"
                                        >
                                            <b-form-input
                                                id="input-billing-address-2"
                                                v-model="create.billingAddress2"
                                                type="text"
                                                placeholder=""
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-city"
                                                >
                                                    <b-form-input
                                                        id="input-billing-city"
                                                        v-model="create.billingCity"
                                                        type="text"
                                                        placeholder="City"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-state"
                                                >
                                                    <b-form-input
                                                        id="input-billing-state"
                                                        v-model="create.billingState"
                                                        type="text"
                                                        placeholder="State"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-zip"
                                                >
                                                    <b-form-input
                                                        id="input-billing-zip"
                                                        v-model="create.billingPostalCode"
                                                        type="text"
                                                        placeholder="Zip"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-country"
                                                >
                                                    <b-form-input
                                                        id="input-billing-country"
                                                        v-model="create.billingCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                    <b-col>
                                        <b-form-group
                                            id="input-group-shipping-address-1"
                                            label="Shipping Address Line 1:"
                                            label-for="input-shipping-address-1"
                                            label-size="sm"
                                        >
                                            <b-form-input
                                                id="input-shipping-address-1"
                                                v-model="create.shippingAddress1"
                                                type="text"
                                                placeholder=""
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group
                                            id="input-group-shipping-address-2"
                                            label="Shipping Address Line 2:"
                                            label-for="input-shipping-address-2"
                                            label-size="sm"
                                        >
                                            <b-form-input
                                                id="input-shipping-address-2"
                                                v-model="create.shippingAddress2"
                                                type="text"
                                                placeholder=""
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-city"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-city"
                                                        v-model="create.shippingCity"
                                                        type="text"
                                                        placeholder="City"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-state"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-state"
                                                        v-model="create.shippingState"
                                                        type="text"
                                                        placeholder="State"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-zip"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-zip"
                                                        v-model="create.shippingPostalCode"
                                                        type="text"
                                                        placeholder="Zip"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-country"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-country"
                                                        v-model="create.shippingCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                </b-form-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Notes">
                            <b-card-text>
                                <b-form-group
                                    id="textarea-group-notes"
                                    label="Notes:"
                                    label-for="textarea-notes"
                                    label-size="sm"
                                >
                                    <b-form-textarea
                                        id="textarea-notes"
                                        v-model="create.notes"
                                        placeholder=""
                                        rows="7"
                                        size="sm"
                                        no-resize
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Tax Info">
                            <b-card-text>
                                <b-form-group
                                    id="input-group-ein"
                                    label="EIN #:"
                                    label-for="input-ein"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-ein"
                                        v-model="create.ein"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Preferred Payment & Delivery">
                            <b-card-text>
                                <b-form-row>
                                    <b-col>
                                        <b-form-group
                                            id="select-group-terms"
                                            label="Terms:"
                                            label-for="select-terms"
                                            label-size="sm"
                                        >
                                            <b-form-select
                                                v-model="create.terms"
                                                id="select-term"
                                                size="sm"
                                                :options="lists.terms"
                                            ></b-form-select>
                                        </b-form-group>
                                        <b-form-group
                                            id="textarea-group-banking-info"
                                            label="Banking Info:"
                                            label-for="textarea-banking-info"
                                            label-size="sm"
                                        >
                                            <b-form-textarea
                                                id="textarea-banking-info"
                                                v-model="create.bankingInfo"
                                                placeholder=""
                                                rows="5"
                                                size="sm"
                                                no-resize
                                            ></b-form-textarea>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-opening-balance"
                                                    label="Opening Balance:"
                                                    label-for="input-opening-balance"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-opening-balance"
                                                        v-model="create.openingBalance"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="datepicker-group-opening-balance-date"
                                                    label="as of:"
                                                    label-for="datepicker-opening-balance-date"
                                                    label-size="sm"
                                                >
                                                    <b-form-datepicker
                                                        id="datepicker-opening-balance-date"
                                                        v-model="create.openingBalanceDate"
                                                        class="mb-2"
                                                        size="sm"
                                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                        locale="en"
                                                    >
                                                    </b-form-datepicker>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                </b-form-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Additional Info">
                            <b-card-text></b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>
                <b-form-row class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Creating...
                            </span>
                            <span v-else>Create</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [

		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-lists-vendors-create-vendor',
                create: {
                    name: '',
                    email: '',
                    mobile: '',
                    phone: '',
                    fax: '',
                    website: '',
                    billingAddress1: '',
                    billingAddress2: '',
                    billingCity: '',
                    billingState: '',
                    billingPostalCode: '',
                    billingCountry: '',
                    shippingAddress1: '',
                    shippingAddress2: '',
                    shippingCity: '',
                    shippingState: '',
                    shippingPostalCode: '',
                    shippingCountry: '',
                    terms: '',
                    contact: '',
                    bankingInfo: '',
                    ein: '',
                    notes: '',
                    company: ''
                },
                lists: {
                    terms: [
                        'Straight Ship',
                        'Net 30',
                        'COD MO',
                        'COD CC',
                        'Credit Card',
                    ]
                },
                submitting: 0,
			}
		},

		methods: {
            createvendor() {
                this.submitting = 1
                let createData = this.create

                let url = 'api/lists/vendors/createvendor'
                axios.post(url, {
                    createData
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'Success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Vendor Created', 'Vendor created successfully!')
                        this.$emit('getRow')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error creating customer!')
                    }
                }, () => {
                    this.has_error = true
                })
            }
		},

		computed: {

		},

		mounted() {

		}
	}
</script>
<style lang="scss">
    #modal-lists-vendors-create-vendor {
        .modal-content {
            .button-row {
                margin-top: 15px;
            }
        }
    }
</style>
